import { LogEntry } from "projects/common/core/services/log/models/log.entry";
import { Observable } from "rxjs";

export abstract class LogPublisher {
	abstract log(record: LogEntry): Observable<boolean>;
}